import cn from 'classnames';

import ICO_BRANDING from 'assets/images/icons/bookmark-square-black.svg';
import ExternalLink from 'components/generic/ExternalLink.component';
import Foldout from 'components/generic/Foldout.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import SectionSeparator from 'settings/online-booking/pages/SectionSeparator.component';

import CN from './Policy.module.scss';

const LINK_MAIL = 'mailto:info@getslick.com';

const PolicySection = ({ title, children }) => (
  <div className={CN.gap}>
    <div className={CN.title}>{title}</div>
    <div className={CN.text}>{children}</div>
  </div>
);

const Policy = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      data-bem="Policy"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <Foldout tag="Policy__fold" src={ICO_BRANDING} title={t('staffAndBusiness.privacyPolicy.foldoutTitle')} isOpen={true} width="max">
        <SectionSeparator />

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section1Title')}>{t('staffAndBusiness.privacyPolicy.section1Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section2Title')}>{t('staffAndBusiness.privacyPolicy.section2Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section3Title')}>{t('staffAndBusiness.privacyPolicy.section3Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section4Title')}>{t('staffAndBusiness.privacyPolicy.section4Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section5Title')}>{t('staffAndBusiness.privacyPolicy.section5Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section6Title')}>{t('staffAndBusiness.privacyPolicy.section6Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section7Title')}>{t('staffAndBusiness.privacyPolicy.section7Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section8Title')}>{t('staffAndBusiness.privacyPolicy.section8Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section9Title')}>
          {t('staffAndBusiness.privacyPolicy.section9DescriptionPart1')}
          <ExternalLink link={LINK_MAIL} variant="inline">
            <span className={CN.linkTo}>{t('staffAndBusiness.privacyPolicy.infoLink')}</span>
          </ExternalLink>
          {t('staffAndBusiness.privacyPolicy.section9DescriptionPart2')}
        </PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section10Title')}>{t('staffAndBusiness.privacyPolicy.section10Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section11Title')}>{t('staffAndBusiness.privacyPolicy.section11Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section12Title')}>{t('staffAndBusiness.privacyPolicy.section12Description')}</PolicySection>

        <PolicySection title={t('staffAndBusiness.privacyPolicy.section13Title')}>
          <p>{t('staffAndBusiness.privacyPolicy.section13DescriptionPart1')}</p>
          <p>
            {t('staffAndBusiness.privacyPolicy.section13DescriptionPart2')}
            <ExternalLink link={LINK_MAIL} variant="inline">
              <span className={CN.linkTo}>{t('staffAndBusiness.privacyPolicy.infoLink')}</span>
            </ExternalLink>
            {t('staffAndBusiness.privacyPolicy.section13DescriptionPart3')}
          </p>
          {t('staffAndBusiness.privacyPolicy.section13DescriptionPart4')}
        </PolicySection>
      </Foldout>
    </div>
  );
};

export default Policy;
